import { PropTypes } from "react";
import CommentActions from "../../../react_actions/comment_actions";
import GrComponentFactory from "../../gr_component_factory";

export default GrComponentFactory.createClass({
  displayName: "NewsfeedItemFooterCommentButton",

  propTypes: {
    subjectKey: PropTypes.string.isRequired,
  },

  onClick() {
    CommentActions.textareaFocusRequested(this.props.subjectKey);
  },

  render() {
    return (
      <button className="gr-buttonAsLink" onClick={this.onClick}>
        Comment
      </button>
    );
  },
});
